import { EditTpSlType, GenericTradeParams } from '@ui/features/Trade/types';
import { Order } from '@ui/hooks/trade/useTradeOrders/types';
import { ContractPairMaxTpRatios } from '@ui/services/contract/hooks/TradingConfigFacet/useGetPairMaxTpRatios/query';
import { TradePair } from '@ui/types/tradePair';
import BigNumber from 'bignumber.js';

export const toGenericTradeParams = ({
  order,
  openFeeP,
  lvTokenDiscountP,
  executionFee,
}: {
  order: Order;
  openFeeP: number;
  lvTokenDiscountP: number;
  executionFee: BigNumber;
}): GenericTradeParams['genericTradeParams'] & {
  type: EditTpSlType;
} => {
  return {
    ...order,
    type: EditTpSlType.ORDER,
    entryPrice: order.triggerPrice,
    getLeverage: ({
      collateralTokenMarketPrice,
    }: {
      collateralTokenMarketPrice: BigNumber;
    }) => {
      return order.getLeverage({
        collateralMarketPrice: collateralTokenMarketPrice,
        executionFee: executionFee,
        lvTokenDiscountP,
        openFeeP: openFeeP,
      });
    },
    getLiquidationPrice: ({
      collateralMarketPrice,
      liqLostP,
      tradePair,
    }) => {
      return order.getLiquidationPrice({
        collateralMarketPrice,
        openFeeP,
        lvTokenDiscountP,
        liqLostP,
        executionFee,
        tradePair,
      });
    },
    getStopLossDeltaPnl: ({
      pairMarketPrice,
      collateralTokenMarketPrice,
      tradePair,
    }: {
      pairMarketPrice: BigNumber;
      collateralTokenMarketPrice: BigNumber;
      tradePair: TradePair;
    }) => {
      return order.getStopLossDeltaPnl({
        pairMarketPrice,
        collateralTokenMarketPrice,
        openFeeP,
        lvTokenDiscountP,
        executionFee,
        tradePair,
      });
    },
    getStopLossPercentage: ({
      pairMarketPrice,
      collateralTokenMarketPrice,
      tradePair,
    }: {
      pairMarketPrice: BigNumber;
      collateralTokenMarketPrice: BigNumber;
      tradePair: TradePair;
    }) => {
      return order.getStopLossPercentage({
        pairMarketPrice,
        collateralTokenMarketPrice,
        openFeeP,
        lvTokenDiscountP,
        executionFee,
        tradePair,
      });
    },
    getTakeProfitDeltaPnl: ({
      collateralTokenMarketPrice,
      pairMarketPrice,
      tradePair,
    }: {
      pairMarketPrice: BigNumber;
      collateralTokenMarketPrice: BigNumber;
      tradePair: TradePair;
    }) => {
      return order.getTakeProfitDeltaPnl({
        collateralTokenMarketPrice,
        openFeeP,
        lvTokenDiscountP,
        executionFee,
        pairMarketPrice,
        tradePair,
      });
    },
    getTakeProfitPercentage: ({
      collateralTokenMarketPrice,
      tradePair,
    }: {
      pairMarketPrice: BigNumber;
      collateralTokenMarketPrice: BigNumber;
      tradePair: TradePair;
    }) => {
      return order.getTakeProfitPercentage({
        collateralTokenMarketPrice,
        openFeeP,
        lvTokenDiscountP,
        executionFee,
        tradePair,
      });
    },
    getMaxTpRatiosPrice: ({
      collateralTokenMarketPrice,
      maxTakeProfitP,
      currentPairMaxTpRatios,
      pairMarketPrice,
      tradePair,
    }: {
      collateralTokenMarketPrice: BigNumber;
      pairMarketPrice: BigNumber;
      currentPairMaxTpRatios: ContractPairMaxTpRatios[];
      maxTakeProfitP: number;
      tradePair: TradePair;
    }) => {
      return order.getMaxTpRatiosPrice({
        collateralTokenMarketPrice,
        currentPairMaxTpRatios,
        maxTakeProfitP,
        lvTokenDiscountP,
        executionFee,
        openFeeP,
        pairMarketPrice,
        tradePair,
      });
    },
    getCollateralUsd: (collateralMarketPrice: BigNumber) => {
      return order.getCollateralUsd({
        collateralMarketPrice,
        openFeeP,
        lvTokenDiscountP,
        executionFee,
      });
    },
  };
};
